import { useQuery } from '@tanstack/react-query'
import { getMediaPicture } from '@/api'
import { queryKeys } from '@/query/queryKeys'

export function useDepartmentPic(ids: number[]) {
  return useQuery({
    enabled: !!ids.length,
    queryKey: queryKeys.departmentPic(ids),
    queryFn: async ({ signal }) => {
      if (!signal?.aborted)
        return getMediaPicture('department', ids)
    },
    retry: false,
    staleTime: 1000 * 60 * 15,
  })
}
